import { Card, CardItem } from 'src/app/components/Elements/Card';

const IdVerificationRequired = () => {
  return (
    <Card style="blue">
      <CardItem>
        <h3>We&#8217;ll need to verify your photo ID for this delivery.</h3>
        <small>Schedule a time and place where you will be able to show your ID.</small>
      </CardItem>
    </Card>
  );
};

export default IdVerificationRequired;
